import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Spinner } from "react-bootstrap";
import { useAppContext } from "../../Context/AppContext";
import { useGetMembershipCancellationStatus } from "../../api/queries/useGetMembershipCancellationStatus";
import { useTranslation } from "react-i18next";

/** Legacy key; pending state now comes from the API. Remove any stale value on load. */
const LEGACY_CANCELLATION_PENDING_KEY = "smbf_cancellation_request_pending";

const ManageMembership: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { objectId } = useAppContext();

  useEffect(() => {
    try {
      localStorage.removeItem(LEGACY_CANCELLATION_PENDING_KEY);
    } catch {
      // ignore
    }
  }, []);

  const { data, isLoading, isError } = useGetMembershipCancellationStatus(
    !!objectId
  );
  const cancellationRequestPending =
    !isError && data?.hasPendingCancellationRequest === true;

  return (
    <div className="pb-4 m-0">
      <div className="card shadow-lg border-0 p-4">
        <h4 className="fw-semibold mb-4">{t("membership.manageTitle")}</h4>
        <div className="row g-3">
          <div className="col-12 col-md-6">
            <Card className="h-100 border shadow-sm">
              <Card.Body>
                <Card.Title>{t("membership.upgradeMembership")}</Card.Title>
                <Card.Text className="text-muted">
                  {t("membership.changePlanOrRenew")}
                </Card.Text>
                <Button
                  variant="primary"
                  onClick={() => navigate("/renew-membership")}
                >
                  {t("membership.upgradeRenew")}
                </Button>
              </Card.Body>
            </Card>
          </div>
          <div className="col-12 col-md-6">
            <Card
              className={`h-100 border shadow-sm ${cancellationRequestPending ? "opacity-75" : ""}`}
            >
              <Card.Body>
                <Card.Title>{t("membership.cancelMembership")}</Card.Title>
                {isLoading ? (
                  <div className="d-flex align-items-center gap-2 text-muted py-2">
                    <Spinner animation="border" size="sm" />
                    <span>{t("feed.loading")}</span>
                  </div>
                ) : cancellationRequestPending ? (
                  <>
                    <Card.Text className="text-muted mb-0">
                      {t("membership.cancellationPendingMessage")}
                    </Card.Text>
                    <div className="mt-3 small text-secondary">
                      {t("membership.requestStatusPendingAdmin")}
                    </div>
                  </>
                ) : (
                  <>
                    <Card.Text className="text-muted">
                      {t("membership.requestCancelMembership")}
                    </Card.Text>
                    <Button
                      variant="outline-danger"
                      onClick={() => navigate("/cancel-membership")}
                    >
                      {t("membership.cancelMembership")}
                    </Button>
                  </>
                )}
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageMembership;
